import {Dexie, type EntityTable} from "dexie";
import ChatSession from "@src/types/ChatSession";
import Tag from "@src/types/Tag";
import TemplateMessage from "@src/types/TemplateMessage";
import ChatMessage from "@src/types/ChatMessage";
import Channel from "@src/types/Channel";
import Kanban from "@src/types/Kanban";
import VCard from "@src/types/VCard";
import Contact from "@src/types/Contact";
import Department from "@src/types/Department";
import Location from "@src/types/Location";
import Group from "@src/types/Group";
import GroupMessage from "@src/types/GroupMessage";

export const db = new Dexie("dChatDatabase") as Dexie & {
    sessions: EntityTable<ChatSession, 'id'>,
    vcards: EntityTable<VCard, 'id'>,
    departments: EntityTable<Department, 'id'>
    channels: EntityTable<Channel, 'id'>
    kanbans: EntityTable<Kanban, 'id'>,
    tags: EntityTable<Tag, 'id'>,
    contacts: EntityTable<Contact, 'id'>,
    messages: EntityTable<ChatMessage, 'id'>
    locations: EntityTable<Location, 'id'>
    template_messages: EntityTable<TemplateMessage, 'id'>,
    groups: EntityTable<Group, 'id'>,
    group_messages: EntityTable<GroupMessage, 'id'>,
};

db.version(1).stores({
    sessions: "id, updated_at, is_fixed, is_archive, status, kanban_card, [status+updated_at], costumer.id",
    messages: "id, from, chat_session_id, created_at",
    departments: "id",
    channels: "id , type, status",
    kanbans: "id, order, is_default",
    contacts: "id, costumer_id",
    vcards: "id",
    tags: "id",
    template_messages: "id , trigger, department_id",
    locations: "id",
    groups: "id, name, last_message_date",
    group_messages: "id, group_id",
});

db.open().then(() => {
    // console.log('IndexedDB aberto')
}).catch(err => {
    console.error('Erro ao abrir IndexedDB', err)
})